import { Card, Grid, Typography, Box, InputAdornment, TextField } from '@mui/material'
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { doCatalogsSync } from 'redux/actions/catalogsSync/catalogsSyncActions'
import RegularButton from 'components/CustomButtons/Button'
import { useSearch } from 'hooks/useSearch'
import { GlobalBox } from 'components/Box/GlobalBox'
import { ModalV2 } from 'components/Modal/ModalV2'
import { useToggle } from 'hooks/useToggle'
import { CloudSync, PublishedWithChanges, ErrorOutline } from '@mui/icons-material'
import { columns } from './columns'
import CardTable from 'components/CardTable/CardTable'
import './styles.css';
import { LoadingComponent } from 'components/Loading/LoadingComponent'
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

const tableKey = 'CatalogsSync'
const title = "Sincronizar Catálogos";

export const CatalogsSync = () => {
  const { setSnackbar, buildCompLoadings, buildTableConfig } = useSearch();
  const { isError, catalogsSyncLog, catalogsSync } = useSelector(({ catalogsSync }) => catalogsSync)
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const [data, setData] = useState([])
  const [isOpen, handleIsOpen, handleIsOpenValue] = useToggle();
  const dispatch = useDispatch()
  const { SUPPORT_SYNC_CATALOG_APRO } = PERMISSIONS
  const hasRule = useRuleValidator(SUPPORT_SYNC_CATALOG_APRO);

  const handleSubmit = useCallback(() => {
    dispatch(doCatalogsSync(handleIsOpenValue));
  }, [setSnackbar]);

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey)
    buildCompLoadings(["loadingCatalogsSync"]);
  }, []);

  useEffect(() => {
    const rows = Object.keys(catalogsSync)
    if(rows.length) {
      setData(rows.map((name) => ({
        name,
        changesCount: catalogsSync[name],
      })))
    } 
  }, [catalogsSync]);
  
  return (
    <>
      <GlobalBox
        icon={<CloudSync />}
        title={title}
      >
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={3} style={{display: 'flex', justifyContent: 'center'}}>
            <RegularButton 
              onClick={handleIsOpen} 
              color='info' 
              style={{
                height: '100%', 
                margin: 0
              }} 
              disabled={!hasRule || isLoadingComp?.loadingCatalogsSync}
            >
              {title}
            </RegularButton>
          </Grid>
          <Grid item xs={12}>
          {
            isError 
              ? <Card style={{width: '100%', height: '68vh', padding: '2rem'}}>
                  <Box sx={{
                    borderRadius: '10px 10px 0px 0px',
                    overflow: 'hidden',
                    color: 'whitesmoke',
                    display: 'flex',
                    backgroundColor: '#13131a',
                    position: 'relative',
                    zIndex: 1,
                    marginBottom: -2
                  }}>
                    <Box sx={{
                      backgroundColor: '#2c2c2c',
                      display: 'flex',
                      padding: 1,
                      width: '40%',
                      borderTopRightRadius: 10
                    }}>
                      <ErrorOutline color='error' style={{ marginRight: 8 }}/>
                      <Typography>Log de errores al sincronizar</Typography>
                    </Box>
                    <Box sx={{
                      width: '60%'
                    }}/>
                  </Box>
                  <TextField
                    inputProps={{ readOnly: true }}
                    InputProps={{
                      startAdornment: 
                        <InputAdornment position="start">
                          <span style={{color: 'red'}}>
                            {'>> Error: '}
                          </span>
                        </InputAdornment>
                    }}
                    id="outlined-multiline-static"
                    value={catalogsSyncLog}
                    maxRows={20}
                    defaultValue=""
                    multiline
                    variant="outlined"
                    sx={{ 
                      width: '100%',
                      height: '96%',
                      "& .Mui-disabled": {
                        height: '96%'
                      },
                      "& .MuiInputBase-root": {
                        height: '96%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignContent: 'flex-start',
                        backgroundColor: '#2c2c2c',
                        color: '#00ff00',
                        fontFamily: "courier new",
                        paddingTop: 4.6
                      },
                      "& .MuiInputBase-inputMultiline": {
                        width: '84%'
                      },
                      "& .MuiInputAdornment-root": {
                        alignSelf: 'baseline',
                        flexWrap: 'wrap'
                      }
                    }}
                  />
                </Card>
              : <CardTable
                  title={"Cambios Registrados"}
                  data={data}
                  columns={columns}
                  hasHeader
                  blockBtn
                  icon={<PublishedWithChanges />}
                  isLoading={isLoadingComp?.loadingCatalogsSync}
                  tableKey={tableKey}
                />
          }
          </Grid>
        </Grid>
      </GlobalBox>
      <ModalV2
        title={"Estas seguro de sincronizar catálogos?"}
        justConfirm
        open={isOpen}
        onClose={handleIsOpen}
        minHeight={2}
        textAlign="center"
        textMargin={28}
      >
        {
          isLoadingComp?.loadingCatalogsSync 
            ? <LoadingComponent label="Sincronizando datos" height="8vh" />
            : <>
                <RegularButton
                  color="transparent"
                  onClick={handleIsOpen}
                >
                  Cancelar
                </RegularButton>
                <RegularButton
                  color="success"
                  onClick={handleSubmit}
                  disabled={!hasRule || isLoadingComp?.loadingCatalogsSync}
                >
                  Confirmar
                </RegularButton>
            </>
        }
      </ModalV2>
    </>
  )
}
